
  export const TOTAL_ROWS = 96;
  export const ROW_HEIGHT = 15; // pixels per 15-minute row

  export const DRAG_ACTIVATION_DISTANCE = 8;

const APPOINTMENT_BLOCK_PALETTE = [
  { bg: "bg-pink-500", text: "text-background" },
  { bg: "bg-purple-500", text: "text-background" },
  { bg: "bg-emerald-500", text: "text-background" },
  { bg: "bg-pink-700", text: "text-background" },
  { bg: "bg-purple-700", text: "text-background" },
  { bg: "bg-emerald-700", text: "text-background" },
  { bg: "bg-pink-300", text: "text-foreground" },
  { bg: "bg-purple-300", text: "text-foreground" },
  { bg: "bg-emerald-300", text: "text-foreground" },
  { bg: "bg-pink-900", text: "text-background" },
  { bg: "bg-purple-900", text: "text-background" },
  { bg: "bg-emerald-900", text: "text-background" },
  { bg: "bg-pink-100", text: "text-foreground" },
  { bg: "bg-purple-100", text: "text-foreground" },
  { bg: "bg-emerald-100", text: "text-foreground" },
] as const;

export function appointmentBlockColorClasses(
  categoryId: number | null
): string {
  if (categoryId == null) {
    return "bg-primary text-background";
  }
  const swatch =
    APPOINTMENT_BLOCK_PALETTE[categoryId % APPOINTMENT_BLOCK_PALETTE.length];
  return `${swatch.bg} ${swatch.text}`;
}

/** Stack below `sm`; Stylist and Service share leftover width equally; Duration/Time stay compact. */
export const APPOINTMENT_SERVICE_ROW_GRID =
  "grid grid-cols-1 items-start gap-3 sm:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_7rem_7rem_2rem]";

const APPOINTMENT_STATUS_VALUES = [
  "booked",
  "confirmed",
  "arrived",
  "left_message",
  "no_show",
  "cancelled",
  "completed",
] as const;

export const APPOINTMENT_STATUS_OPTIONS = [
  { value: "booked", label: "Booked" },
  { value: "confirmed", label: "Confirmed" },
  { value: "arrived", label: "Arrived" },
  { value: "left_message", label: "Left Message" },
  { value: "no_show", label: "No Show" },
  { value: "cancelled", label: "Cancelled" },
  { value: "completed", label: "Completed" },
] as const satisfies ReadonlyArray<{
  value: (typeof APPOINTMENT_STATUS_VALUES)[number];
  label: string;
}>;

type AppointmentStatusValue = (typeof APPOINTMENT_STATUS_VALUES)[number];

export const appointmentStatusLabel = (status: AppointmentStatusValue): string =>
  APPOINTMENT_STATUS_OPTIONS.find((option) => option.value === status)?.label ?? status;
type CalendarAppointmentStatus = Exclude<AppointmentStatusValue, "completed">;

const isCalendarAppointmentStatus = (
  status: AppointmentStatusValue
): status is CalendarAppointmentStatus => status !== "completed";

/** Completing is Sales-only. */
export const APPOINTMENT_CALENDAR_STATUS_VALUES =
  APPOINTMENT_STATUS_VALUES.filter(isCalendarAppointmentStatus);

export const APPOINTMENT_CALENDAR_STATUS_OPTIONS =
  APPOINTMENT_STATUS_OPTIONS.filter(
    (
      option
    ): option is Extract<
      (typeof APPOINTMENT_STATUS_OPTIONS)[number],
      { value: CalendarAppointmentStatus }
    > => isCalendarAppointmentStatus(option.value)
  );
